<div class="setting" *ngIf="settingsForm">
  <div class="setting_container" *ngIf="page === 'replenish' && !data?.isPoFilter" [formGroup]="settingsForm">
    <app-page-container-devider [title]="'Target Stock Days'" [small]="true"
      [matTooltip]="'Minimum remaining days of stock to keep in the channels FCs'"
      [matTooltipPosition]="'above'"></app-page-container-devider>
    <div class="input-container  my-2">
      <input class="input-container_input input-container_input--extra-thin" type="number" min="0"
        formControlName="minDays" />
    </div>
    <div class="setting_footer px-0 pb-0 justify-content-between">
      <app-button [buttonSize]="'action'" [buttonStyle]="'text'" (click)="redirectToSettings()">More
        Settings</app-button>
      <app-button [buttonSize]="'action'" [spin]="showLoader" (click)="saveSettings()">Apply</app-button>
    </div>
  </div>
  <div class="setting_container" *ngIf="page === 'purchasing' || page === 'purchase-by-sku'" [formGroup]="settingsForm">
    <app-page-container-devider [title]="'Purchase Days'" [small]="true"></app-page-container-devider>

    <div class="input-container">
      <mat-checkbox formControlName="useStockDays">Override vendor settings</mat-checkbox>
    </div>

    <div class="input-container">
      <input class="input-container_input input-container_input--extra-thin" type="number" min="0"
        formControlName="purchaseDays" />
    </div>
    <div class="setting_footer px-0 pb-0 justify-content-between">
      <app-button [buttonSize]="'action'" [buttonStyle]="'text'" (click)="redirectToSettings()">More
        Settings</app-button>
      <app-button [buttonSize]="'action'" [spin]="showLoader" (click)="saveSettings()">Save</app-button>
    </div>
  </div>
  
</div>

<div class="setting" *ngIf="page === 'replenish' && data?.isPoFilter">
  <div class="setting_container">
    <app-page-container-devider [title]="'Filter PO Id'" [small]="true"></app-page-container-devider>
    <input class="input-container_input input-container_input--extra-thin" type="number" [formControl]="filterPoId" />
    <div class="setting_footer px-0 pb-0 justify-content-end">
      <app-button [buttonSize]="'action'" [isDisabled]="!filterPoId.value" [spin]="spin" (click)="savePOFilter()">Save</app-button>
    </div>
  </div>
</div>  
